<template>
  <table class="table-box">
    <slot></slot>
  </table>
</template>

<script>
export default {
  name: "TableBox",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.table-box {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid $secondary;
  @include mq-down(md) {
    border-bottom: 0;
  }
}
</style>
